// CSS
import "./App.css";
// import ThemeSetter from "./common/theme/components/themeshetter";
import ThemeProvider from "./common/theme/components/contexts/themeprovider";
import React, {
  useState,
  useContext,
  createContext,
  useEffect,
  useRef,

  useMemo
} from "react";
import {
  // PaymentRequestButtonElement,
  useStripe,
  // useElements,
} from "@stripe/react-stripe-js";
import { connect } from "react-redux";
import { setStripe } from "./actions/stripe/setStripeActions";
import { tracker } from "./utils/openreplay";
import reportWebVitals from "./reportWebVitals";
import { Helmet } from "react-helmet";
import Spinner from "react-bootstrap/Spinner";
import { getHomepage } from "./actions/home/homepageActions";
import { getFooter } from "./actions/home/footerAction";
// import { isMobile, isAndroid, isIOS, isWebView } from 'react-device-detect';
import Franchise from "./pages/franchise/main";
export const OrderFlowProvider = createContext({});
export const OrderFlow = () => useContext(OrderFlowProvider);
const Flag = React.lazy(() => import("./flag"));
const RestaurantMain = React.lazy(() => import("./pages/restuarant-page/main"));
const TakeawayMain = React.lazy(() => import("./pages/takeaway-page/main"));
const ThemeSetter = React.lazy(() => import("./common/theme/components/themeshetter"));

function App({ apiResponse,
  setStripe,
  getHomepage,
  response,
}) {
  const stripe = useStripe();
  const mobileref = useRef();
  const [headerButtonResponse, setHeaderButtonResponse] = useState(null);
  //header state
  const [getLogo, setLogo] = useState(null);
  const [getUrlLink, setUrlLink] = useState();
  const [getImageUrl, setImageUrl] = useState();
  const [getImageAlt, setImageAlt] = useState();
  //header button state
  const [cartButtonText, setCartButtonText] = useState(null);
  const [contactUsButtonText, setContactUsButtonText] = useState(null);
  const [franchiseButtonText, setFranchiseButtonText] = useState(null);
  const [orderNowButtonText, setOrderNowButtonText] = useState(null);
  const [subscriptionButtonText, setSubscriptionButtonText] = useState(null);
  //header button url
  const [cartButtonURL, setCartButtonURL] = useState(null);
  const [contactUsButtonURL, setContactUsButtonURL] = useState(null);
  const [orderNowButtonURL, setOrderNowButtonURL] = useState(null);
  const [subscriptionButtonURL, setSubscriptionButtonURL] = useState(null);
  const [franchiseButtonURL, setFranchiseButtonURL] = useState(null);
  //our-Branch
  const [ourBranchData, setOurBranchData] = useState(null);
  //galleryGrid 
  const [galleryGridData, setGalleyGridData] = useState(null);

  useEffect(() => {
    if (stripe) {
      setStripe(stripe); // Dispatch the Stripe object to Redux
    }
  }, [stripe, setStripe]);

  useEffect(() => {
    tracker.start();
  }, []);

  useEffect(() => {
    const favicon = document.getElementById("favicon");
    const appleIcon = document.getElementById("appleIcon");
    const chromeIcon192 = document.getElementById("chromeIcon192");
    const chromeIcon512 = document.getElementById("chromeIcon512");
    const googlePageIdsec = document.getElementById("googlePageId");
    // console.log("getLogo:", getLogo);
    if (getLogo) {
      if (favicon) favicon.href = getLogo;
      if (appleIcon) appleIcon.href = getLogo;
      if (chromeIcon192) chromeIcon192.href = getLogo;
      if (chromeIcon512) chromeIcon512.href = getLogo;
      if (googlePageIdsec) googlePageIdsec.href = getLogo;
    }
  }, [getLogo]);
  const [oneTabShow, setOneTabShow] = useState(true);
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const oneTabShowMemoized = useMemo(() => {
    return isLoggedIn === "true" ? false : true;
  }, [isLoggedIn]);
  // Update oneTabShow state only when oneTabShowMemoized changes


  useEffect(() => {
    if (response) {
      setUrlLink(response?.data?.header?.orderNowLink);
      setImageUrl(response?.data?.header?.logoImage);
      setImageAlt(response?.data?.header?.businessName);
      setLogo(response?.data?.header?.b2cLogo);
    }
  }, [response])
  const [clientCheck, setClientCheck] = useState(null);
  //app signin
  const [loginPopupShow, setLoginPopupShow] = useState(false);
  const [appLoginPopupShow, setAppLoginPopupShow] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [currentPage, setCurrentPage] = useState("signIn"); // "signIn" or "otp"
  const [getOrderTime, setOrderTime] = useState(
    localStorage.getItem("orderTime"));
  const [getOrderMode, setOrderMode] = useState(
    localStorage.getItem("orderMode")
      ? localStorage.getItem("orderMode")
      : "Delivery");
  const [getCollectionTab, setCollectionTab] = useState(true);
  const [getDeliveryTab, setDeliveryTab] = useState(true);
  const [moveToCheck, setMoveToCheck] = useState(
    localStorage.getItem("moveToCheck")
      ? localStorage.getItem("moveToCheck")
      : false);
  const [stuartStatus, setStuartStatus] = useState(false);
  const [restaurant, setRestaurant] = useState(null);
  const [footerLoading, setFooterLoading] = useState(false);
  //postcode change
  const [reslimit, setReslimit] = useState(1);
  const [restaurantData, setRestaurantData] = useState([]);
  const [hasFetchedData, updateHasFetchedData] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [cartQuantity, setCartQuantity] = useState(null);

  //activated
  const [activatedPopup, setActivatedPopup] = useState(false);
  const [lastOrder, setLastOrder] = useState(false);
  //currency
  const [currencyPopup, setCurrencyPopup] = useState(false);
  const [currency, setCurrency] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState(null);
  //flag App  show
  const [flagShow, setFlagShow] = useState(true);
  const width = window.innerWidth;
  const breakPoint = 767;
  //menufilterShow mobile
  const [menuFilterShow, setMenuFilterShow] = useState(false);

  //mui popup subcribe
  const [open, setOpen] = useState(false);
  const [subcribeButtonstatus, setSubcribeButtonstatus] = useState(false);
  // const apiResponse1 = "2";
  localStorage.setItem("apiRes", apiResponse);


  useEffect(() => {
    const postData = {
      domain: window.location.hostname,
    };
    getHomepage(postData);
    // getMenuImage(postData);
    setFooterLoading(true);
    setCartQuantity(localStorage.getItem("cartQty"));
    if (width > breakPoint) {
      setFlagShow(false);
    }
    else {
      setFlagShow(true);
    }

    const currentPath = window.location.pathname;
    const AppCheck = currentPath?.includes("/app");
    if (AppCheck) {
      setFlagShow(false)
    }

    const getApplink = localStorage.getItem("appLink") ? JSON.parse(localStorage.getItem("appLink")) : '';
    if (getApplink === '') {
      setFlagShow(false)
    }
    else if (getApplink?.oneLinkUrl === '') {
      setFlagShow(false)
    }
  }, []);

  //sso one link
  // const googleSigin=localStorage.getItem('google_login');
  // const appleSigin=localStorage.getItem('apple_login');
  // const faceBookSigin=localStorage.getItem('facebook_login');
  // if(googleSigin|| appleSigin || faceBookSigin){
  //   setFlagShow(false)
  // }

  useEffect(() => {
    setOneTabShow(oneTabShowMemoized);
  }, [oneTabShowMemoized]);
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        //  setIpAddress(data.ip);
        localStorage.setItem("ip", data.ip);
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
      });
  }, []);
  //one link check sso login
  useEffect(() => {
    const extractParameters = () => {
      const queryParams = new URLSearchParams(window.location.search);
      const googleLoginParam = queryParams.get("google_login");
      const facebookLoginParam = queryParams.get("facebook_login");
      const appleLoginParam = queryParams.get("apple_login");

      if (googleLoginParam === "1") {
        queryParams.delete("google_login");
        const remainingParams = {};
        queryParams.forEach((value, key) => {
          remainingParams[key] = value;
        });
        setFlagShow(false);
        // window.history.replaceState({}, document.title, newUrl);
      } else if (facebookLoginParam === "1") {
        queryParams.delete("facebook_login");
        const remainingParams = {};
        queryParams.forEach((value, key) => {
          remainingParams[key] = value;
        });
        setFlagShow(false);
      } else if (appleLoginParam === "1") {
        queryParams.delete("apple_login");
        const remainingParams = {};
        queryParams.forEach((value, key) => {
          remainingParams[key] = value;
        });
        setFlagShow(false);
      }
      else {
        // localStorage.setItem("google_login", "");
        // localStorage.setItem("facebook_login", "");
        // localStorage.setItem("apple_login", "");
      }
    };

    extractParameters();
  }, []);
  // const [isWebView, setIsWebView] = useState(false); // State to track if it's a WebView
  // const [environment, setEnvironment] = useState(''); // State to store detected environment

  // useEffect(() => {
  //   detectEnvironment();
  // }, []);

  // const detectEnvironment = () => {
  //   // Detect if it's a mobile device and if it's running inside a WebView
  //   if (isMobile) {
  //     if (isWebView) {
  //       setIsWebView(true);
  //       if (isAndroid) {
  //         setEnvironment('Android WebView');
  //       } else if (isIOS) {
  //         setEnvironment('iOS WebView');
  //       }
  //     } else {
  //       // If it's mobile but not in WebView
  //       if (isAndroid) {
  //         setEnvironment('Android Browser');
  //       } else if (isIOS) {
  //         setEnvironment('iOS Browser');
  //       }
  //     }
  //   } else {
  //     // Not a mobile device
  //     setEnvironment('Browser (Desktop or Non-Mobile)');
  //   }
  // };
  // useEffect(() => {
  //   detectAppEnvironment();
  // }, []);

  // const detectAppEnvironment = () => {
  //   const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  //   // Check for Android WebView
  //   if (/android/i.test(userAgent)) {
  //     if (/wv|webview/i.test(userAgent)) {
  //       console.log('Running in Android WebView');
  //       setIsWebView(true);
  //       setEnvironment('Android WebView');
  //       return;
  //     } else if (/chrome|crios|fxios/i.test(userAgent)) {
  //       console.log('Running in Android Browser');
  //       setIsWebView(false);
  //       setEnvironment('Android Browser');
  //       return;
  //     }
  //   }

  //   // Check for iOS WebView
  //   if (/iPhone|iPad|iPod/i.test(userAgent)) {
  //     if (/wv|webview/i.test(userAgent) || /AppleWebKit/i.test(userAgent)) {
  //       console.log('Running in iOS WebView');
  //       setIsWebView(true);
  //       setEnvironment('iOS WebView');
  //       return;
  //     } else if (/safari/i.test(userAgent)) {
  //       console.log('Running in iOS Browser');
  //       setIsWebView(false);
  //       setEnvironment('iOS Browser');
  //       return;
  //     }
  //   }

  //   // Default: Assume regular browser (mobile or desktop)
  //   console.log('Running in a regular browser');
  //   setIsWebView(false);
  //   setEnvironment('Browser');
  // };

  useEffect(() => {
    // console.log(footerLoading);
  }, [footerLoading]);

  const handleclick = () => {
    setFooterLoading(false);
  };

  const TopQty = () => {
    const cartQty = localStorage.getItem("cartQty");
    setCartQuantity(cartQty);
  };

  const handleActivated = () => {
    setActivatedPopup(true);
  };

  // table booking changes 
  const handleBookSeatClick = () => {
    setShowBookingForm(true); // Show booking form
  };

  //currency changes
  const handleCurrencyPopup = () => {
    setCurrencyPopup(true);
  }
  const handleCurrencyChange = (v) => {
    setCurrency(v.currencyName);
    localStorage.setItem("currencySymbol", v.currencySymbol);
    localStorage.setItem("currencyName", v.currencyName);
    setCurrencyPopup(false);
  }

  const [businessTitle, setBusinessTitle] = useState("");
  const isSingUp = localStorage?.getItem("isLoggedIn") === "true" ? true : false;
  const clientAppLogo = localStorage.getItem("clientAppLogo") ? localStorage.getItem("clientAppLogo") : '';
  return (
    <>
      <Helmet>
        <style type="text/css">{`
        @media only screen and (min-width: 320px) and (max-width: 767px) {
               #light-dark-tool {
        display: none;
    }     
        }
    `}</style>
      </Helmet>

      <ThemeProvider>
        <OrderFlowProvider.Provider
          value={{
            loginPopupShow,
            setLoginPopupShow,
            currentPage,
            setCurrentPage,
            getOrderTime,
            setOrderTime,
            getOrderMode,
            setOrderMode,
            getCollectionTab,
            setCollectionTab,
            getDeliveryTab,
            setDeliveryTab,
            moveToCheck,
            setMoveToCheck,
            stuartStatus,
            setStuartStatus,
            restaurant,
            setRestaurant,
            footerLoading,
            setFooterLoading,
            handleclick,
            reslimit,
            setReslimit,
            restaurantData,
            setRestaurantData,
            hasFetchedData,
            updateHasFetchedData,
            mobileref,
            searchQuery,
            setSearchQuery,
            businessTitle,
            setBusinessTitle,
            TopQty,
            activatedPopup,
            setActivatedPopup,
            handleActivated,
            setLogo,
            lastOrder,
            setLastOrder,
            clientCheck,
            setClientCheck,
            isSingUp,
            headerButtonResponse,
            setHeaderButtonResponse,
            flagShow, setFlagShow,
            clientAppLogo,
            getUrlLink, setUrlLink,
            getImageUrl, setImageUrl,
            getImageAlt, setImageAlt,
            currency, setCurrency,
            currencySymbol, setCurrencySymbol,
            handleCurrencyChange,
            currencyPopup, setCurrencyPopup,
            handleCurrencyPopup,
            menuFilterShow, setMenuFilterShow,
            appLoginPopupShow, setAppLoginPopupShow,
            oneTabShow,
            setOneTabShow,
            open, setOpen,
            subcribeButtonstatus, setSubcribeButtonstatus,
            cartButtonText, setCartButtonText,
            contactUsButtonText, setContactUsButtonText,
            franchiseButtonText, setFranchiseButtonText,
            franchiseButtonURL, setFranchiseButtonURL,
            orderNowButtonText, setOrderNowButtonText,
            subscriptionButtonText, setSubscriptionButtonText,
            cartButtonURL, setCartButtonURL,
            contactUsButtonURL, setContactUsButtonURL,
            orderNowButtonURL, setOrderNowButtonURL,
            subscriptionButtonURL, setSubscriptionButtonURL,
            ourBranchData, setOurBranchData,
            galleryGridData, setGalleyGridData,
            showBookingForm, setShowBookingForm,
            handleBookSeatClick,
          }}>
          {clientCheck &&
            apiResponse !== 2 &&
            <ThemeSetter />}
          {flagShow ? (<>
            {width < 767 &&
              <Flag />
            }
          </>
          ) : (
            <>
              {apiResponse === 1 ? (
                <React.Suspense
                  fallback={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center', // Center horizontally
                        alignItems: 'center', // Center vertically
                        height: '100vh', // Full viewport height
                        width: '100%', // Full viewport width
                      }}
                    >
                      <Spinner
                        animation="border"
                        size="md"
                        variant="success"
                        style={{
                          display: "flex", // Use flexbox
                          justifyContent: "center", // Center horizontally
                          alignItems: "center",
                        }}
                      /></div>}>
                  <RestaurantMain />
                </React.Suspense>
              ) : (
                apiResponse === 0 ? (
                  <React.Suspense
                    fallback={
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center', // Center horizontally
                          alignItems: 'center', // Center vertically
                          height: '100vh', // Full viewport height
                          width: '100%', // Full viewport width
                        }}>
                        <Spinner
                          animation="border"
                          size="md"
                          variant="success"
                          style={{
                            display: "flex", // Use flexbox
                            justifyContent: "center", // Center horizontally
                            alignItems: "center",
                          }}
                        /></div>}>
                    <TakeawayMain />
                  </React.Suspense>
                ) : (
                  <React.Suspense
                    fallback={
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center', // Center horizontally
                          alignItems: 'center', // Center vertically
                          height: '100vh', // Full viewport height
                          width: '100%', // Full viewport width
                        }}>
                        <Spinner
                          animation="border"
                          size="md"
                          variant="success"
                          style={{
                            display: "flex", // Use flexbox
                            justifyContent: "center", // Center horizontally
                            alignItems: "center",
                          }}
                        /></div>}>
                    <Franchise />
                  </React.Suspense>)
              )}
            </>
          )}
        </OrderFlowProvider.Provider>
      </ThemeProvider>
    </>
  );
}
const mapStateToProps = (state) => ({
  response: state.footer.response,
});
const mapDispatchToProps = {
  setStripe,
  getHomepage,
  getFooter,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(tracker.setMetadata);
